// **** serviços ****
// **** autor: Walcledson de Paula ****
// **** 10-08-24
// **** atualizado: 10-8-24 - 23h19 ****
// **** atualizado: 13-8-24 - 12h27 ****
// **** atualizado: 24-8-24 - 14h48 ****
// **** 22-10-24w | 19h31 | eliminado <Dock/> | criado p_servico_editar.jsx / p_servico_novo.jsx ****
// **** 24-12-24w | 11h40 | acrescentado foto do serviço na exibição ****



import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Dock } from 'react-dock'; // Importe o Dock
import Icon from '@mdi/react'; // icone do material design icones pra padronizar o home do mobile/desktop (delphi) no web 2/7/24w
import { mdiPlusCircle, mdiNoteEdit } from '@mdi/js'; // Adicionado mdiNoteEdit para editar serviço
import { Oval } from 'react-loader-spinner';
import Swal from "sweetalert2";
import apiaxios from "../../../../../Services/apiaxios.js";
import { decrypt } from "../../../../../Services/cryptoUtils.js";
import handleApiError from "../../../../../Services/apiErrorHandler.js";
import { AutoLogout } from "../../../../../Services/autologout.js";

import CardServico from '../../../Components/Servicos/p_cardservico.jsx';
import Menu from '../../../Components/Menu/p_menu.jsx';
import Footer from '../../../../AgendexCliente/components/Footer/footer.jsx';

import './p_servicos.css';
import { p_getUserData } from "../../../../../Services/p_userutils.js";

function Servicos() {
    // se ajusta de acordo com o sistema (mobile, tablet, nb, pc, etc)
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const [loading, setLoading] = useState(false);
    const [servicos, setServicos] = useState([]);
    const [selectedServico, setSelectedServico] = useState(null);
    const [nenhumServicoEncontrado, setNenhumServicoEncontrado] = useState(false);
    const [dockOpen, setDockOpen] = useState(false); // Gerencia o estado do Dock
    const [dockOperation, setDockOperation] = useState(""); // Gerencia a operação do Dock
    const openDock = () => setDockOpen(true);
    const closeDock = () => setDockOpen(false); // fechar o dock de dentro do componente p-cardservico.jsx
    const navigate = useNavigate();

    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    useEffect(() => {
        // const tokenASW = localStorage.getItem("tokenasw");
        const tokenlg = localStorage.getItem("tokenlg");
        
        if (!tokenASW || !tokenlg) {
            AutoLogout();
        }
    }, []);

    const initialUserData = p_getUserData();
    const [userId, setUserId] = useState(initialUserData.userId);
    const [indEmpresa, setIndEmpresa] = useState(initialUserData.indEmpresa || 0);
    const [emailValidado, setEmailValidado] = useState(initialUserData.emailValidado || 0);
    const [validado, setValidado] = useState(initialUserData.validado); // CPF/CNPJ validado =1 (se ainda não foi validado = 0)
    const [bloqueio, setBloqueio] = useState(initialUserData.bloqueio); // se contrato vencido ou não (0= não vencido / 1=vencido)

    useEffect(() => {
        if (validado !== 1) {
            Swal.fire('Erro', 'Cadastro em validação... favor aguardar e tentar novamente mais tarde!', 'error');
            navigate('/app/prestador/home');
        } else if (bloqueio !== 0) {
            Swal.fire('Contrato Vencido', 'Cadastro bloqueado. Escolha um de nossos planos para continuar usando o AgendeX', 'error');
            navigate('/app/prestador/home');
        }
    }, [validado, bloqueio, navigate]); // acrescetando 12/9/24w "navigate" pois estava gerando o hint/warning: "Line 147:8:   React Hook useEffect has a missing dependency: 'navigate'. Either include it or remove the dependency array"

    useEffect(() => {
        if (userId) {
            loadServicos(userId);
        }
    }, [userId]);

    const loadServicos = async (id_usuario) => {
        try {
            setLoading(true);
            const response = await apiaxios.get(`/servico/listarWeb?id_empresa=${id_usuario}&token=${tokenASW}&id_usuario=${id_usuario}`);
            setLoading(false);
            if (response.status === 200 && response.data.length > 0) {
                setServicos(response.data);
                fetchFotosServicos(response.data);
            } else {
                setNenhumServicoEncontrado(true);
            }
        } catch (error) {
            setLoading(false);
            handleApiError(error);
        }
    };

    const formatCurrency = (value) => {
        if (value === undefined || value === null) {
            return 'R$ 0,00';
        }
        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    const handleAlterar = (servico) => {
        setSelectedServico(servico); // Define o serviço selecionado.
        setDockOperation("edit");
        setDockOpen(true); // Abre o Dock
    };

    const handleAdicionar = () => {
        setDockOperation("add");
        setDockOpen(true); // Abre o Dock
    };

    const handleDesativar = (id_servico) => {
        // alert('Função desativar temporariamente');
        Swal.fire({
            title: 'Confirmação',
            text: 'Confirma a desativação temporária do Serviço id #' + id_servico + ' ?' ,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, desativar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                fetchDesativarServico(id_servico);
            }
        })
    };

    const fetchDesativarServico = async (id_servico) => {
        setLoading(true);
            try {
                const response = await apiaxios.put('servico/desativarWeb', {
                    id_servico,
                    id_status : 9
                },
                {
                    params: { 
                        id_empresa: userId,
                        token: tokenASW,
                        id_usuario: userId
                    }
                }
                );
                if (response.status === 200) {
                    const data = response.data;
                    // console.log(data);
                    if (data.retorno === 'OK') {
                        Swal.fire('Informação', 'Serviço desativado temporariamenteo com sucesso!', 'success');
                        loadServicos(userId);
                    } else {
                        Swal.fire('Erro', data.retorno, 'error');
                    }
                } else { if (response.status !== 200) {
                    const data = response.data;
                    Swal.fire('Erro', data.retorno, 'error');
                    } else {
                        Swal.fire('Erro', 'Falha ao desativar o serviço. Tente novamente mais tarde.', 'error');
                    }
                }
            } catch (error) {
                handleApiError(error);
            } finally {
                setLoading(false);
            }
    };    

    const handleReativar = (id_servico) => {
        // alert('Função desativar temporariamente');
        Swal.fire({
            title: 'Confirmação',
            text: 'Confirma a reativação do Serviço id #' + id_servico + ' ?' ,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, reativar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                fetchReativarServico(id_servico);
            }
        })
    };

    const fetchReativarServico = async (id_servico) => {
        setLoading(true);
            try {
                const response = await apiaxios.put('servico/desativarWeb', {
                    id_servico,
                    id_status : 8
                    },
                    {
                        params: { 
                            id_empresa: userId,
                            token: tokenASW,
                            id_usuario: userId
                        }
                    }
                );
                if (response.status === 200) {
                    const data = response.data;
                    // console.log(data);
                    if (data.retorno === 'OK') {
                        Swal.fire('Informação', 'Serviço reativado com sucesso!', 'success');
                        loadServicos(userId);
                    } else {
                        Swal.fire('Erro', data.retorno, 'error');
                    }
                } else { if (response.status !== 200) {
                    const data = response.data;
                    Swal.fire('Erro', data.retorno, 'error');
                    } else {
                        Swal.fire('Erro', 'Falha ao reativar o serviço. Tente novamente mais tarde.', 'error');
                    }
                }
            } catch (error) {
                handleApiError(error);
            } finally {
                setLoading(false);
            }
    };    

    const handleExcluir = (id_servico) => {
        // alert('Função excluir');
        Swal.fire({
            title: 'Confirmação',
            text: 'Confirma a exclusão do Serviço id #' + id_servico + ' ?' ,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                fetchExcluirServico(id_servico);
            }
        })
        // Código comentado para exclusão
    };

    const fetchExcluirServico = async (id_servico) => {
        setLoading(true);
            try {
                const response = await apiaxios.delete('servico/crudWeb', {
                    params: { id_empresa: userId,
                        id_servico,
                        token: tokenASW,
                        id_usuario: userId
                    }
                });
                if (response.status === 200) {
                    const data = response.data;
                    if (data.retorno === 'OK') {
                        Swal.fire('Informação', 'Serviço excluído com sucesso!', 'success');
                        loadServicos(userId);
                    } else {
                        Swal.fire('Erro', data.retorno, 'error');
                    }
                } else { if (response.status !== 200) {
                    const data = response.data;
                    Swal.fire('Erro', data.retorno, 'error');
                    } else {
                        Swal.fire('Erro', 'Falha ao excluir o serviço. Tente novamente mais tarde.', 'error');
                    }
                }
            } catch (error) {
                handleApiError(error);
            } finally {
                setLoading(false);
            }
    };    

    // carrega as fotos miniaturas de cada serviço
    // const fetchFotosServicos = (servicosFotos) => {
    //     // console.log('fetchFotosServicos servicosFotos: ', servicosFotos);
    //     const promises = servicosFotos.map(async (servico, index) => {
    //         try {
    //             const fotoResponse = await apiaxios.get(`/servico/FotoMiniWeb?id_servico=${servico.ID_SERVICO}&id_usuario=${userId}&token=${tokenASW}`);
    //             // console.log('fotoResponseData :', fotoResponse.data);
    //             // console.log('fotoResponseFoto :', fotoResponse.data.foto);
    //             if (fotoResponse.data.retorno === "OK" && fotoResponse.data.foto) {
    //                 // console.log('fotoResponse :', fotoResponse.data.foto);
    //                 servico.SER_FotoMini = `data:image/jpeg;base64,${fotoResponse.data.fotomini}`;
    //                 servico.SER_Foto = `data:image/jpeg;base64,${fotoResponse.data.foto}`;
    //             }
    //         } catch (error) {
    //             handleApiError(error);
    //         } finally {
    //             // Update the state with the new data including the photo
    //             setServicos(prevDados => {
    //                 const newDados = [...prevDados];
    //                 newDados[index] = servico;
    //                 return newDados;
    //             });
    //         }
    //     });
    //     return Promise.all(promises);
    // };
    const fetchFotosServicos = (servicosFotos) => {
        const promises = servicosFotos.map(async (servico, index) => {
            try {
                const fotoResponse = await apiaxios.get(`/servico/FotoMiniWeb?id_servico=${servico.ID_SERVICO}&id_usuario=${userId}&token=${tokenASW}`);

                if (fotoResponse.data.retorno === "OK") {
                    // Correção crucial: verifique se foto e fotomini existem separadamente
                    // if (fotoResponse.data.foto) {
                    //     servico.SER_Foto = `data:image/jpeg;base64,${fotoResponse.data.foto}`;
                    // } else {
                    //     servico.SER_Foto = null; // Ou uma imagem padrão
                    // }
                    if (fotoResponse.data.fotomini) {
                         servico.SER_FotoMini = `data:image/jpeg;base64,${fotoResponse.data.fotomini}`;
                    } else {
                        servico.SER_FotoMini = null; // Ou uma imagem padrão
                    }
                } else {
                    console.error("Erro ao carregar fotos:", fotoResponse.data.retorno);
                    // servico.SER_Foto = null;
                    servico.SER_FotoMini = null;
                }
            } catch (error) {
                console.error("Erro na requisição de fotos:", error);
                // servico.SER_Foto = null;
                servico.SER_FotoMini = null;
                handleApiError(error); // Mantém o tratamento de erro
            } finally {
                setServicos(prevDados => {
                    const newDados = [...prevDados];
                    newDados[index] = servico;
                    return newDados;
                });
            }
        });
        return Promise.all(promises);
    };



    return (
        <>
            <div className="c_detalheempresa">
                <div className="container-fluid">
                    <div className="row flex-nowrap">
                        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                            <Menu page="servicos"/>
                        </div>
                        <div className="col py-3 me-3">
                            <h1 className="text-center">Serviços</h1>
                            <hr />
                            <div className="text-right">
                                <button className="btn btn-primary m-2" onClick={handleAdicionar}>
                                    <Icon path={mdiPlusCircle} size={1}/> Novo Serviço
                                </button>
                            </div>
                            {loading ? (
                                <div className="loading-spinner-container">
                                    <Oval color="#00BFFF" height={70} width={70} />
                                </div>
                            ) : (
                                nenhumServicoEncontrado ? (
                                    <div className="alert alert-danger mt-2" role="alert">
                                        Nenhum "Serviço" disponível neste momento... comece a cadastrar agora mesmo (+)
                                    </div>
                                ) : (
                                    <div className="box-explorarempresas">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Foto</th>
                                                    <th>Descrição</th>
                                                    <th>Duração</th>
                                                    <th>Valor</th>
                                                    <th>Vr Desconto</th>
                                                    <th>Vr Total</th>
                                                    <th>% Desconto</th>
                                                    <th className="text-right">Ações</th>
                                                </tr>
                                            </thead>  
                                            <tbody>
                                                {servicos.map((servico, index) => (
                                                    <tr key={servico.ID_SERVICO}>
                                                        <td data-label="Id:">{servico.ID_SERVICO}</td>
                                                        <td data-label="Foto:">
                                                            {servico.SER_FotoMini ? (
                                                                <img src={servico.SER_FotoMini} alt={servico.SER_FotoMini} className="servico-foto"/> /*height="50" width="50"*/
                                                            ) : (
                                                                'Sem Foto'
                                                            )}
                                                        </td>
                                                        <td data-label="Descrição:">{servico.DESCRICAO}</td>
                                                        {servico.ID_STATUS !== 9 ?
                                                            <td data-label="Duração:">{servico.DURACAO}</td>
                                                            :
                                                            <td data-label="Duração:"></td>
                                                        }
                                                        {servico.ID_STATUS !== 9 ?
                                                            <td data-label="Valor:" className={servico.VALOR === 0 ? 'highlight-red' : ''}>
                                                                {servico.VALOR === 0 ? 'VALOR A COMBINAR' : formatCurrency(servico.VALOR)}
                                                            </td>
                                                            : 
                                                            <td data-label="Valor:" className='text-warning bg-dark'>
                                                                SERVIÇO DESATIVADO
                                                            </td>
                                                        }

                                                        {servico.ID_STATUS !== 9 ?
                                                            <td data-label="Vr.Desconto:">
                                                                {servico.VR_DESCONTO === 0 ? 'N/A' : formatCurrency(servico.VR_DESCONTO)}
                                                            </td>
                                                            : 
                                                            <td data-label="Vr.Desconto:" className='text-warning bg-dark'>
                                                                N/A
                                                            </td>
                                                        }
                                                        {servico.ID_STATUS !== 9 ?
                                                            <td data-label="Vr.Total:">
                                                                {servico.VR_TOTAL === 0 ? 'N/A' : formatCurrency(servico.VR_TOTAL)}
                                                            </td>
                                                            : 
                                                            <td data-label="Vr.Total:" className='text-warning bg-dark'>
                                                                N/A
                                                            </td>
                                                        }
                                                        {servico.ID_STATUS !== 9 ?
                                                            <td data-label="% Desc.:" className={servico.VR_DESCONTO > 0 ? 'text-right highlight-red' : 'text-right'}>
                                                                {servico.VR_TOTAL === 0 ? 'N/A' : `${(servico.VR_DESCONTO / servico.VALOR * 100).toFixed(2)} %`}
                                                            </td>
                                                            : 
                                                            <td data-label="% Desc.:" className='text-warning bg-dark'>
                                                                SERVIÇO DESATIVADO
                                                            </td>
                                                        }
                                                        <td className="text-right" data-label="">
                                                            {servico.ID_STATUS !== 9 ?
                                                                <button className="btn btn-warning m-2" onClick={() => handleAlterar(servico)}>
                                                                    <Icon path={mdiNoteEdit} size={1}/> Alterar
                                                                </button>
                                                                :
                                                                <button className="btn btn-success m-2" onClick={() => handleReativar(servico.ID_SERVICO)}>
                                                                    <Icon path={mdiNoteEdit} size={1}/> Reativar
                                                                </button>
                                                            }    
                                                            {servico.ID_STATUS !== 9 ?
                                                                <button className="btn btn-dark m-2" onClick={() => handleDesativar(servico.ID_SERVICO)}>
                                                                    <i className="fa fa-recycle" aria-hidden="true"></i> Desativar
                                                                </button>
                                                                :
                                                                ''
                                                            }
                                                            <button className="btn btn-danger m-2" onClick={() => handleExcluir(servico.ID_SERVICO)}>
                                                                <i className="bi bi-trash-fill"></i> Excluir
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>

            {/* Dock para adicionar/editar serviços */}
            <Dock 
                position="right" 
                isVisible={dockOpen} 
                // onVisibleChange={(visible) => setDockOpen(visible)} 
                // fluid={false}
                // size={350} // era 370 e estava ficando largo demais em celular tela pequena 26/10/24w14h55 // tamanho da tela em tamanho absoluto em pixels
                fluid={true} 
                size={isMobile ? 0.9 : 0.3} // tamanho da tela em fração de %
            >
                <CardServico id_empresa={userId} operacao={dockOperation} servico={selectedServico} openDock={openDock} closeDock={closeDock}/>
            </Dock>
            <Footer />
        </>
    );
}

export default Servicos;